import { render, staticRenderFns } from "./contract_customer_service.vue?vue&type=template&id=008fd504&scoped=true&"
import script from "./contract_customer_service.vue?vue&type=script&lang=js&"
export * from "./contract_customer_service.vue?vue&type=script&lang=js&"
import style0 from "./contract_customer_service.vue?vue&type=style&index=0&id=008fd504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008fd504",
  null
  
)

export default component.exports